const store = (_key: string, _value: unknown) => {
  return
}

const get = (_key: string) => {
  return null
}

export default {
  store,
  get,
}
